'use client'

import * as React from 'react'
import { cn } from '../../../lib/utils'

export type BaseQueryPanelProps = {
  summary: string
  isEmpty?: boolean
  onClear?: () => void
  className?: string
}

export function BaseQueryPanel({
  summary,
  isEmpty = false,
  onClear,
  className,
}: BaseQueryPanelProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-medium text-muted-foreground">Query</span>
        {!isEmpty && onClear ? (
          <button
            type="button"
            onClick={onClear}
            className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Clear
          </button>
        ) : null}
      </div>
      <div
        className={cn(
          'rounded-md border border-border bg-muted/20 px-2.5 py-2 text-xs leading-relaxed',
          isEmpty ? 'text-muted-foreground/70' : 'text-foreground',
        )}
      >
        {summary}
      </div>
    </div>
  )
}
